import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import EventBus from "../../helpers/eventbus";

@Component
export default class OiVideo extends Vue {
    @Prop({ type: String, default: '' })
    videoPlatform!: string;

    @Prop({ type: String, default: '' })
    videoId!: string;

    @Prop({ type: String, default: '' })
    thirdPartyLabel!: string;

    @Prop({ type: Boolean, default: false })
    showVideo!: Boolean;

    @Prop({ type: Boolean, default: false })
    public isInstantly!: boolean;

    @Prop({ type: Boolean, default: false })
    public isAutoplay!: boolean;

    @Prop({ type: String, default: "is-center" })
    public position!: string;

    isInitialized: boolean = false;
    showCookieMessage: boolean = false;
    cookieNameType: string = 'hasThirdPartyConsent';
    video: string = '';

    created() {
        if (this.showVideo) {
            this.launch();
        } else {
            this.destroy();
        }
    }

    @Watch('showVideo')
    onPropertyChanged() {
        if (this.showVideo) {
            this.launch();
        } else {
            this.destroy();
        }
    }

    launch () {
        this.showCookieMessage = false;

        if (this.videoId) {
            if (this.isInstantly) {
                this.loadVideo();
            } else {
                // [TODO] Create only one observer for all video components
                const observer = new IntersectionObserver(
                    entries => {
                        if (!entries[0].isIntersecting) {
                            return;
                        }

                        observer.disconnect();
                        this.loadVideo();
                    },
                    {
                        rootMargin: "100px 100px 667px 100px", // 1 viewport height of an iPhone 7/8
                    },
                );
                observer.observe(this.$el);
            }
        }
    }

    destroy () {
        // Remove all component-specific Cookies
        // BrowserStorage.clearCookie('specific cookies');
        if(this.isInitialized) {
            location.reload();
            return;
        }
        this.showCookieMessage = true;
    }

    openCookieSettings() {
        EventBus.$emit('openCookieBanner',{});
    }

    loadVideo() {
        const iframe = document.createElement('iframe');
        iframe.setAttribute("frameborder", "0");
        iframe.setAttribute("allowfullscreen", "true");
        if (this.videoPlatform == "youtube") {
            iframe.src = "https://www.youtube.com/embed/" + this.videoId + "?feature=oembed&rel0&showinfo=0&modestbranding=1";
            iframe.setAttribute("allow", "encrypted-media");
            if (this.isAutoplay) {
                iframe.src = iframe.src + "&controls=0&mute=1&autoplay=1&loop=1"
                iframe.style.pointerEvents = "none";
                iframe.setAttribute("allow", "autoplay; encrypted-media");
            }

        } else if (this.videoPlatform == "vimeo") {
            iframe.src = "https://player.vimeo.com/video/" + this.videoId + "?h=ba2773e5c3";
            iframe.setAttribute("allow", "fullscreen; picture-in-picture");

            if (this.isAutoplay) {
                iframe.src = iframe.src + "&autoplay=1&loop=1&autopause=0&muted=1&controls=0"
                iframe.setAttribute("allow", "autoplay; fullscreen; picture-in-picture");
            }
        }
        this.video = iframe.outerHTML;

        this.isInitialized = true;
    }
}



// WEBPACK FOOTER //
// ./src/components/scripts/oi-video.ts